// DEV ENV
// const imageProxyUrl = 'http://localhost'
// const proxyUrl = `http://localhost:3001`

// PROD ENV
const imageProxyUrl = 'https://img.beuni.com.br'
const proxyUrl = `https://proxy.beuni.com.br`

/**
 * Generate a proxy URL to render images from S3 Bucket
 * @param {string} recordId Record ID from AirTable
 * @param {object} image Image object from AirTable (e.g. { id: 'rec123', type: 'image/png' })
 * @param {?string} options FlyImage options (e.g. 'w_200,h_200,c_fill')
 * @param {?string} resource Optional resource to fetch image from (e.g. 'orders')
 * @returns Proxy URL to render image
 */
export function getImageProxyUrl(
  recordId,
  image,
  options = null,
  resource = 'products'
) {
  if (!recordId || !image) {
    return ''
  }

  return (
    imageProxyUrl +
    '/upload/' +
    (options ? options + '/' : '') +
    `${proxyUrl}/api/images/${resource}/${recordId}-${image.id}.${
      image.type.split('/')[1]
    }`
  )
}
